export default "/img/BW.357047d65615fe024558eb58cabb2c73.png";